import { AIDetectorProvider } from './ai-detector-context'
import { useBrowserService, useExperimentService, useUserService } from '../../../lib/hooks'
import { useExitIntentModal } from '../../../lib/hooks/experiments/use-exit-intent-modal'
import { AIDetectorDesktop } from './desktop'
import { AIDetectorMobile } from './mobile'
import { Tool } from '@components/tool'
import { AIDetectorUsageModal, AIDetectorFreeUserTrialModal } from './modals'
import { ToolExitIntentModal } from '@components/tool/components/tool-modals'

export const AIDetector = () => {
  const { isMobileOrTablet } = useBrowserService()
  const { isAnonymous } = useUserService().currentUser
  const { isTools2_XWithLoggedInEnabled } = useExperimentService()

  const { inExitIntentExperiment, isExitModalOpen, closeExitModal } = useExitIntentModal()

  if (isTools2_XWithLoggedInEnabled()) {
    return (
      <Tool
        toolType="aiDetector"
        outputTitle="AI Detection results"
        submitButtonText="Scan for AI"
        maxWordLimit={1500}
        minWordLimit={40}
        anonymousUsageLimit={1}
      />
    )
  }

  return (
    <AIDetectorProvider isAnonymous={isAnonymous} appElementForModal="#__next">
      {isMobileOrTablet ? <AIDetectorMobile /> : <AIDetectorDesktop />}
      <AIDetectorUsageModal />
      <AIDetectorFreeUserTrialModal />
      {inExitIntentExperiment && <ToolExitIntentModal isOpen={isExitModalOpen} onClose={closeExitModal} />}
    </AIDetectorProvider>
  )
}
